import { ComponentProps } from "react"

export function Video(props: ComponentProps<"video">) {
	return <video preload="metadata" {...props} />
}
